// JS
import React, { useEffect, useRef } from 'react';
import { useInView } from 'react-intersection-observer';

import { randomId } from '../../shared/utils';

// COMPONENT
const CreativeFeatureVideo = ({
  creativeFeatureVideoOptions,
  data,
  gaBlockName,
  showCreativeFeatureVideo = true,
  lazyLoad = true
}) => {
  const uniqueId = randomId();
  const vidRef = useRef(null);

  useEffect(() => {
    if (!vidRef.current) {
      return;
    }

    vidRef.current.defaultMuted = true;
    vidRef.current.muted = true;
  }, []);

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  return (
    <section
      ref={ref}
      id={'creative-feature-video-' + uniqueId}
      className={
        showCreativeFeatureVideo
          ? 'container my-24 lg:my-48' +
            (creativeFeatureVideoOptions?.classes
              ? ' ' + creativeFeatureVideoOptions.classes
              : '')
          : 'hidden'
      }
    >
      <div
        className={`flex gap-x-6 gap-y-12 md:pt-5 ${
          data?.video_position === 'second'
            ? 'flex-col-reverse md:flex-row-reverse'
            : 'flex-col md:flex-row'
        }`}
      >
        {data && data.video_element && (
          <div
            className="video-container w-full flex flex-col justify-between md:w-6/12"
            data-name={
              data.video_element[0].block_title +
              ' - ' +
              data.video_element[0].block_sub_title
            }
            data-creative={gaBlockName}
            data-id={data.video_element[0].contentguid}
          >
            <div className="flex items-end relative overflow-hidden w-full h-full aspect-[9/7] mb-5 md:mb-10">
              {inView ? (
                <video
                  ref={vidRef}
                  className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 object-cover w-auto h-full"
                  autoPlay
                  muted
                  loop
                  playsInline
                  poster={data.video_element[0].poster}
                >
                  <source
                    src={data.video_element[0].video_link}
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              ) : (
                <img
                  src={data.video_element[0].poster}
                  alt=""
                  loading={lazyLoad ? 'lazy' : 'eager'}
                  className="w-full h-full object-cover"
                />
              )}
            </div>
            <div className="text-lg md:text-xl text-left uppercase">
              <a
                href={data.video_element[0].url}
                target={
                  data.video_element[0].url &&
                  data.video_element[0].url.includes('www.sevenstore.com')
                    ? '_self'
                    : '_blank'
                }
                rel="noreferrer"
              >
                <h2 className="font-bold">
                  {data.video_element[0].block_title}
                </h2>
                <p className="font-base text-md md:text-lg">
                  {data.video_element[0].block_sub_title}
                </p>
              </a>
            </div>
          </div>
        )}
        {data && data.content_element && (
          <a
            key={'creative-feature-1'}
            href={data.content_element[0].url}
            target={
              data.content_element[0].url &&
              data.content_element[0].url.includes('www.sevenstore.com')
                ? '_self'
                : '_blank'
            }
            rel="noreferrer"
            className={`w-full flex flex-col justify-between md:w-6/12`}
            data-name={
              data.content_element[0].block_title +
              ' - ' +
              data.content_element[0].block_sub_title
            }
            data-creative={gaBlockName}
            data-id={data.content_element[0].contentguid}
            data-position={'button-slot-1'}
            data-type="banner-button"
          >
            <div className="flex items-end w-full aspect-[9/7] bg-cover bg-center bg-no-repeat mb-5 md:mb-10">
              <img
                src={data.content_element[0].icon}
                alt={data.content_element[0].alt_text}
                loading={lazyLoad ? 'lazy' : 'eager'}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="text-lg md:text-xl text-left uppercase">
              <h2 className="font-bold">
                {data.content_element[0].block_title}
              </h2>
              <p className="font-base text-md md:text-lg">
                {data.content_element[0].block_sub_title}
              </p>
            </div>
          </a>
        )}
      </div>
      {/* {data && (
        <div
          className="flex flex-col gap-x-6 md:pt-5 md:flex-row"
          // data-name={data[0].block_title + ' & ' + data[1].block_title}
          data-creative={gaBlockName}
          // data-id={data[0].contentguid + '-&-' + data[1].contentguid}
          data-position={'banner-slot-1'}
          data-type="banner"
        >
          {data.map((feature, index) => (
            <a
              key={'creative-feature-video-' + index}
              href={feature.url}
              target={
                feature.url && feature.url.includes('www.sevenstore.com')
                  ? '_self'
                  : '_blank'
              }
              rel="noreferrer"
              className={`w-full flex flex-col justify-between md:w-6/12 ${
                index === 0 ? 'mb-12 md:mb-0' : ''
              }`}
              data-name={feature.block_title + ' ' + feature.block_sub_title}
              data-creative={gaBlockName}
              data-id={feature.contentguid}
              data-position={'button-slot-' + (index + 1)}
              data-type="banner-button"
            >
              <div
                className="flex items-end w-full aspect-[9/7] bg-cover bg-center bg-no-repeat mb-5 md:mb-10"
                style={{
                  backgroundImage: `url('${feature.icon}')`
                }}
              ></div>
              <div className="text-lg md:text-xl text-left uppercase">
                <h2 className="font-bold">{feature.block_title}</h2>
                <p className="font-base text-md md:text-lg">
                  {feature.block_sub_title}
                </p>
              </div>
            </a>
          ))}
        </div>
      )} */}
    </section>
  );
};

export default CreativeFeatureVideo;
